import type { CSSProperties, ComponentProps } from 'react';
import { css, cx } from '../../../styled-system/css';
import { button } from '../../../styled-system/recipes/button';

export type Color = 'secondary' | 'primary' | 'tertiary';
export type Size = 'l' | 'm' | 's';
export type Stretch = 'text' | 'container';

export type BaseButtonProps = {
  /**
   * ボタンのカラーパターンを指定します
   * 以下の３パターンで指定可能です
   * - secondary | primary | tertiary
   */
  color: Color;
  /**
   * ボタンの大きさを指定します
   * 以下の３パターンで指定可能です
   * - l | m | s
   */
  size: Size;
  /**
   * ボタン横幅の伸縮パターンを指定します。
   *
   * 以下の値が指定可能です
   * - text: テキストサイズにより幅が可変します
   * - container: コンテナのサイズに合わせて可変します
   */
  stretch?: Stretch;
  /**
   * ボタンの横幅を指定します
   */
  width?: number;
};

export type ButtonProps = ComponentProps<'button'> & BaseButtonProps;

/**
 * ボタンコンポーネント
 *
 * @see https://www.figma.com/design/ftgyCtqHVci9BMgFZPTnwT/ZEN-ID---%E3%83%87%E3%82%B6%E3%82%A4%E3%83%B3%E3%82%AC%E3%82%A4%E3%83%89?node-id=85-444&t=V6DSSQQTTD0CKycI-0
 */
export function Button({ children, color, size, width, stretch = 'text', className, ...rest }: ButtonProps) {
  return (
    <button
      className={cx(
        button({ color, size, stretch: width ? undefined : stretch }),
        className,
        width ? css({ width: 'var(--button-width)' }) : undefined
      )}
      // FIXME: プロパティ名の型が解決できない。CSSPropertiesへキャストして強制的に解決している
      style={width ? ({ '--button-width': `${width}px` } as CSSProperties) : undefined}
      {...rest}
    >
      {children}
    </button>
  );
}
